import {apiClient} from "../apiClient";

export const TONG_HOP_SINH_VIEN_ENDPOINT = "tong-hop-sinh-vien";

export const tongHopSinhVienApi = {
    SelectLuyKe: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-luy-ke-by-sv/${id_sv}`
        ),
    SelectBienLaiLuyKe: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-bien-lai-luy-ke-by-sv/${id_sv}`
        ),
    SelectMucThuLuyKe: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-muc-thu-luy-ke-by-sv/${id_sv}`
        ),
    SelectSoDu: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-so-du-by-sv/${id_sv}`
        ),
    SelectTinChiThuaHuy: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-tin-chi-thua-huy-by-sv/${id_sv}`
        ),
    // Đối soát đã nộp (biên lai) vs định mức (mức thu) theo khoản/kỳ — giải thích RÕ thừa/thiếu ở đâu.
    SelectDoiSoatDaNopDinhMuc: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-doi-soat-da-nop-dinh-muc-by-sv/${id_sv}`
        ),
    SelectTinChiLichSu: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-tin-chi-lich-su-by-sv/${id_sv}`
        ),
    // Học phần ĐÃ RÚT / ĐÃ XÓA / ĐÃ HỦY — API RIÊNG, cố tình KHÔNG gộp vào SelectMucThuLuyKe
    // vì endpoint đó đang phục vụ Giấy xác nhận học phí, Dashboard SV và Reset công nợ.
    SelectTinChiDaRut: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-tin-chi-da-rut-by-sv/${id_sv}`
        ),
};

/** 1 dòng log tổng hợp tín chỉ theo lớp của sinh viên (dashboard). */
export interface ILopTinChiLichSu {
    id: number;
    id_sv: string;
    id_lop_tc: number;
    hoc_lai: number;
    so_tin_chi: number;
    don_gia: number;
    hoc_phi_theo_hoc_phan: number;
    so_tien_phai_nop: number;
    hoc_ky: number;
    nam_hoc: string;
    ky_dang_ky: number;
    tu_chuc_nang: string;
    hanh_dong: string;
    noi_dung?: string;
    user_id?: string;
    created_date: string;
    ma_mon?: string;
    ten_mon?: string;
    ten_lop_hp?: string;
    mo_ta?: string;
}

export interface ITinChiThuaHuy {
    hoc_ky: number;
    nam_hoc: string;
    id_mon_tc: number;
    ma_mon: string;
    ten_mon: string;
    so_tin_chi: number;
    so_tien: number;
    nguon: string; // "bien_lai" | "so_du"
    /** Số phiếu các biên lai đang giữ tiền (chỉ nguồn "bien_lai", nối ", "). */
    so_phieus: string;
}

/** Đối soát đã nộp (biên lai + tiền gạch từ số dư) vs định mức, theo (khoản × kỳ × năm). */
export interface IDoiSoatDaNopDinhMuc {
    id_thu_chi: number;
    ten_thu_chi: string;
    hoc_ky: number;
    nam_hoc: string;
    dinh_muc: number;
    /** Nộp qua biên lai THU. */
    da_nop: number;
    /** Đã hoàn lại cho SV bằng phiếu CHI (chưa hủy) — phải trừ khỏi "đã nộp". */
    hoan_phieu_chi: number;
    /** Rút số dư gạch vào khoản này (ví → khoản). */
    gach_tu_so_du: number;
    /** Tiền của khoản đã chuyển sang số dư (khoản → ví): phiếu thu trước, phần nộp dư. */
    chuyen_vao_so_du: number;
}
